var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionimage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4652_89856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4.5H1C0.448667 4.5 0 4.05133 0 3.5V1.5C0 0.948667 0.448667 0.5 1 0.5H15C15.5513 0.5 16 0.948667 16 1.5V3.5C16 4.05133 15.5513 4.5 15 4.5ZM1 1.16667C0.816 1.16667 0.666667 1.316 0.666667 1.5V3.5C0.666667 3.684 0.816 3.83333 1 3.83333H15C15.184 3.83333 15.3333 3.684 15.3333 3.5V1.5C15.3333 1.316 15.184 1.16667 15 1.16667H1Z",
    fill: "#999FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 10.4987H1C0.448667 10.4987 0 10.05 0 9.4987V6.83203C0 6.2807 0.448667 5.83203 1 5.83203H6.33333C6.88467 5.83203 7.33333 6.2807 7.33333 6.83203V9.4987C7.33333 10.05 6.88467 10.4987 6.33333 10.4987ZM1 6.4987C0.816 6.4987 0.666667 6.64803 0.666667 6.83203V9.4987C0.666667 9.6827 0.816 9.83203 1 9.83203H6.33333C6.51733 9.83203 6.66667 9.6827 6.66667 9.4987V6.83203C6.66667 6.64803 6.51733 6.4987 6.33333 6.4987H1Z",
    fill: "#999FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 16.4987H1C0.448667 16.4987 0 16.05 0 15.4987V12.832C0 12.2807 0.448667 11.832 1 11.832H6.33333C6.88467 11.832 7.33333 12.2807 7.33333 12.832V15.4987C7.33333 16.05 6.88467 16.4987 6.33333 16.4987ZM1 12.4987C0.816 12.4987 0.666667 12.648 0.666667 12.832V15.4987C0.666667 15.6827 0.816 15.832 1 15.832H6.33333C6.51733 15.832 6.66667 15.6827 6.66667 15.4987V12.832C6.66667 12.648 6.51733 12.4987 6.33333 12.4987H1Z",
    fill: "#999FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 10.4987H9.66675C9.11541 10.4987 8.66675 10.05 8.66675 9.4987V6.83203C8.66675 6.2807 9.11541 5.83203 9.66675 5.83203H15.0001C15.5514 5.83203 16.0001 6.2807 16.0001 6.83203V9.4987C16.0001 10.05 15.5514 10.4987 15.0001 10.4987ZM9.66675 6.4987C9.48275 6.4987 9.33341 6.64803 9.33341 6.83203V9.4987C9.33341 9.6827 9.48275 9.83203 9.66675 9.83203H15.0001C15.1841 9.83203 15.3334 9.6827 15.3334 9.4987V6.83203C15.3334 6.64803 15.1841 6.4987 15.0001 6.4987H9.66675Z",
    fill: "#999FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 16.4987H9.66675C9.11541 16.4987 8.66675 16.05 8.66675 15.4987V12.832C8.66675 12.2807 9.11541 11.832 9.66675 11.832H15.0001C15.5514 11.832 16.0001 12.2807 16.0001 12.832V15.4987C16.0001 16.05 15.5514 16.4987 15.0001 16.4987ZM9.66675 12.4987C9.48275 12.4987 9.33341 12.648 9.33341 12.832V15.4987C9.33341 15.6827 9.48275 15.832 9.66675 15.832H15.0001C15.1841 15.832 15.3334 15.6827 15.3334 15.4987V12.832C15.3334 12.648 15.1841 12.4987 15.0001 12.4987H9.66675Z",
    fill: "#999FA3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4652_89856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionimage);
export default __webpack_public_path__ + "static/media/sectionimage.6ecf54b2a0591f049f56e972c97e43c4.svg";
export { ForwardRef as ReactComponent };